module.exports = __webpack_public_path__ + "static/media/pb.f352cb7f.jpg";